import React from "react";
import { Descriptions, Drawer, Tag } from "antd";
import SubtleBadge from "components/common/SubtleBadge";

const formatDateLong = (dateValue) => {
  if (!dateValue) return "-";
  try {
    const d = new Date(dateValue);
    if (isNaN(d)) return "-";
    const datePart = d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const timePart = d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart}, ${timePart.toLowerCase()}`;
  } catch {
    return "-";
  }
};

const STATUS_BADGE_COLORS = {
  PENDING: "warning",
  ACTIVE: "success",
  INACTIVE: "secondary",
  SUSPENDED: "warning",
  CANCELLED: "danger",
};

const PARTNER_TYPE_LABEL = {
  USER: "User",
  ORGANIZATION: "Organization",
};

export default function BusinessGrowthPartnerDetailDrawer({ open, partner, onClose }) {
  if (!partner) return null;

  const statusColor = STATUS_BADGE_COLORS[partner.status] || "secondary";

  return (
    <Drawer
      title={
        <span>
          Partner Details — <strong>{partner.displayName || partner.referralCode || "—"}</strong>
        </span>
      }
      open={open}
      onClose={onClose}
      width={560}
      push={false}
      zIndex={1050}
    >
      <Descriptions column={1} bordered size="small" labelStyle={{ fontWeight: 600, width: 180 }}>
        <Descriptions.Item label="Display Name">
          {partner.displayName || "-"}
        </Descriptions.Item>

        <Descriptions.Item label="Email">
          {partner.email || "-"}
        </Descriptions.Item>

        <Descriptions.Item label="Referral Code">
          {partner.referralCode ? (
            <SubtleBadge bg="light" className="fw-bold" style={{ fontSize: "0.7rem" }}>
              {partner.referralCode}
            </SubtleBadge>
          ) : (
            "-"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Type">
          {partner.partnerType ? (
            <SubtleBadge bg="info" style={{ fontSize: "0.7rem" }}>
              {PARTNER_TYPE_LABEL[partner.partnerType] || partner.partnerType}
            </SubtleBadge>
          ) : (
            "-"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Status">
          <SubtleBadge
            bg={statusColor}
            className="fw-bold"
            style={{
              borderRadius: "4px",
              padding: "2px 6px",
              fontSize: "0.7rem",
              textTransform: "uppercase",
            }}
          >
            {partner.status || "—"}
          </SubtleBadge>
        </Descriptions.Item>

        <Descriptions.Item label="Status Reason">
          {partner.statusReason ? (
            <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {partner.statusReason}
            </span>
          ) : (
            <span style={{ color: "#999" }}>—</span>
          )}
        </Descriptions.Item>

        <Descriptions.Item label="User ID">
          <Tag style={{ fontFamily: "monospace", fontSize: "0.75rem" }}>{partner.userId || "—"}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Business Entity ID">
          <Tag style={{ fontFamily: "monospace", fontSize: "0.75rem" }}>
            {partner.businessEntityId || "—"}
          </Tag>
        </Descriptions.Item>

        <Descriptions.Item label="ID">
          <Tag style={{ fontFamily: "monospace", fontSize: "0.75rem" }}>{partner.id || "—"}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Created">
          {formatDateLong(partner.createdAt)}
        </Descriptions.Item>

        <Descriptions.Item label="Updated">
          {formatDateLong(partner.updatedAt)}
        </Descriptions.Item>

        <Descriptions.Item label="Created By">
          <Tag style={{ fontFamily: "monospace", fontSize: "0.75rem" }}>
            {partner.createdBy || "—"}
          </Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Updated By">
          <Tag style={{ fontFamily: "monospace", fontSize: "0.75rem" }}>
            {partner.updatedBy || "—"}
          </Tag>
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}
